<button
  *ngIf="showButtons && !scrollStartReached"
  class="nav-prev-btn {{colorScheme.main}}" (click)="prev()"
>
  <mat-icon>arrow_back_ios</mat-icon>
</button>
<div
  *ngIf="fadeOut"
  class="fade-out {{colorScheme.main}}"
  [class.hidden]="scrollStartReached">
</div>
<div #sliderRef class="slider" [class.smooth-scroll]="smoothScroll" draggable="false">
  <ng-content></ng-content>
  <lib-slider-item-more *ngIf="moreButtonRouterLink || moreButtonLink"
                        [title]="moreButtonTitle"
                        [link]="moreButtonLink"
                        [routerLink]="moreButtonRouterLink"
                        [small]="moreButtonSmall">
  </lib-slider-item-more>
</div>
<div
  *ngIf="fadeOut"
  class="fade-out {{colorScheme.main}}"
  [class.hidden]="scrollEndReached">
</div>
<button
  *ngIf="showButtons && !scrollEndReached"
  class="nav-next-btn {{colorScheme.main}}" (click)="next()"
>
  <mat-icon>arrow_forward_ios</mat-icon>
</button>
